import api from './interceptor';
import {mainUrl} from './Urls';

export async function getJobPreferencesApi() {
	const response = await api.get(mainUrl + '/auth/job-preferences/', {
		headers: {
			Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
		},
	});
	return response;
}

export async function updateJobPreferencesApi(data) {
	const response = await api.post(
		mainUrl + '/auth/job-preferences/',
		{
			preferred_categories: data,
		},
		{
			headers: {
				Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
			},
		}
	);
	return response;
}
